import { AlertTriangle } from "lucide-react";

const ROICalculator = () => {
  return (
    <section className="py-24 px-8 bg-destructive/5 border-t border-b border-destructive/20">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-destructive/10 mb-6">
            <AlertTriangle className="w-8 h-8 text-destructive" />
          </div>
          <h2 className="text-4xl font-light text-foreground mb-4">
            Institutional Risk: The Cost of a Single NCAA Violation
          </h2>
          <p className="text-lg font-light text-muted-foreground max-w-[700px] mx-auto">
            For athletic departments and compliance offices, one oversight can cost millions — and threaten the program's future
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="border border-destructive/20 rounded-lg p-8 bg-background">
            <h3 className="text-sm uppercase tracking-wider text-destructive/60 mb-2 font-light">
              Average NCAA Investigation
            </h3>
            <div className="space-y-4">
              <div className="flex justify-between items-center pb-3 border-b border-border/50">
                <span className="text-sm text-muted-foreground font-light">Legal fees</span>
                <span className="text-base font-medium text-foreground">$1.2M - $3.5M</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-border/50">
                <span className="text-sm text-muted-foreground font-light">Lost bowl revenue</span>
                <span className="text-base font-medium text-foreground">$4M - $8M</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-border/50">
                <span className="text-sm text-muted-foreground font-light">Scholarship reductions</span>
                <span className="text-base font-medium text-foreground">$500K/year × 4</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-border/50">
                <span className="text-sm text-muted-foreground font-light">Reputation damage</span>
                <span className="text-base font-medium text-destructive">Priceless</span>
              </div>
              <div className="flex justify-between items-center pt-2">
                <span className="text-base font-semibold text-foreground">Direct Cost Range</span>
                <span className="text-xl font-semibold text-destructive">$5.7M - $11.5M</span>
              </div>
            </div>
          </div>

          <div className="border-2 border-primary/30 rounded-lg p-8 bg-primary/5">
            <h3 className="text-sm uppercase tracking-wider text-primary/60 mb-2 font-light">
              AthleteNexus Enterprise
            </h3>
            <div className="space-y-6">
              <div>
                <div className="text-5xl font-light text-foreground mb-2">$75K</div>
                <div className="text-sm text-muted-foreground font-light">/year</div>
              </div>
              
              <div className="py-6 border-y border-border/50">
                <div className="text-sm text-muted-foreground font-light mb-2">Return on Investment</div>
                <div className="text-4xl font-light text-primary mb-1">76:1</div>
                <div className="text-xs text-muted-foreground font-light">Based on avoiding single violation</div>
              </div>

              <div className="space-y-2 text-sm text-muted-foreground">
                <p className="font-light">
                  ✓ Enterprise audit defense (tamper-proof)
                </p>
                <p className="font-light">
                  ✓ Automated conflict detection
                </p>
                <p className="font-light">
                  ✓ Title IX distribution monitoring
                </p>
                <p className="font-light">
                  ✓ 90-day money-back guarantee
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <p className="text-base text-muted-foreground font-light italic">
            Can you afford <span className="font-medium text-foreground">NOT</span> to have institutional defense in place?
          </p>
        </div>
      </div>
    </section>
  );
};

export default ROICalculator;
